import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { flatMap } from 'lodash';

export const CurrentFilterDescriptor = connectCurrentRefinements(
  ({ items }) => {
    const descriptorItems = flatMap(
      items,
      ({ attribute, currentRefinement }) => {
        const minIsSet = currentRefinement.min !== undefined;
        const maxIsSet = currentRefinement.max !== undefined

        // If it's a range
        if (minIsSet || maxIsSet) {
          const { min, max } = currentRefinement;
          const unit = attribute === 'price' ? '$' : '';

          if (minIsSet && maxIsSet) {
            return `${attribute} ${unit + min} - ${unit + max}`;
          } else if (minIsSet) {
            return `${attribute} > ${unit + min}`;
          } else if (maxIsSet) {
            return `${attribute} < ${unit + max}`;
          }
        }

        if (Array.isArray(currentRefinement)) {
          return currentRefinement;
        }
      }
    );

    const descriptionString = descriptorItems.length
      ? descriptorItems.join(', ')
      : 'all';

    return (
      <div>
        <span className="text-50 mr-1 hidden lg:inline">Currently showing</span>
        <span className="uppercase font-bold ml-1">{descriptionString}</span>
      </div>
    );
  }
);
